/* eslint-disable */

import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';
import { DESIGNER_SETTINGS } from '../../../../../app/constants/designer_settings';
import { REGEXES } from '../../../../../app/constants/regexes';
import { openComponentsModal } from '../../../../../app/package-designer/store/package-designer.actions';

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerComponent', [
    '$window',
    '$rootScope',
    '$timeout',
    'DesignerBase',
    'DesignerConnection',
    'DesignerSchema',
    'ngrxStoreService',
    function ($window, $rootScope, $timeout, DesignerBase, DesignerConnection, DesignerSchema, ngrxStoreService) {
      function DesignerComponent() {
        this.COMPONENT_PREFIX = 'component-';
        this.width = DESIGNER_SETTINGS.COMPONENT_WIDTH;
        this.height = DESIGNER_SETTINGS.COMPONENT_HEIGHT;

        this._data = {};
        this.id = this.getId();
        this.shortName = null;
        this.name = null;
        this.originalName = null;
        this.editorDirective = null;
        this.type = null;
        this.componentType = null;
        this.connectionTypes = null;
        this.icon = null;
        this.element = null;
        this.disableSchemaLoad = false;
        this.hasDataPreview = true;
        this.hasDataPreviewRefreshButton = false;
        this.x = 0;
        this.y = 0;

        this.inputs = 0;
        this.inputEdges = [];
        this.inputMin = 0;
        this.inputMax = 0;

        this.outputs = 0;
        this.outputEdges = [];
        this.outputMin = 0;
        this.outputMax = 0;

        this.selected = false;
        this.hover = false;
        this.draggable = false;
        this.connectorDraggable = false;
        this.initiated = false;
        this.edit = false;
      }

      DesignerComponent.prototype = new DesignerBase();

      DesignerComponent.prototype.getId = function () {
        return this.COMPONENT_PREFIX + this.uid();
      };

      DesignerComponent.prototype.setPackage = function (_package) {
        this.package = _package;
        this.designer = _package.designer;
      };

      DesignerComponent.prototype.fixAndSetData = function (data) {
        const fixedData = this.fixData(data);
        this.setData(fixedData);
      };

      DesignerComponent.prototype.setData = function (data) {
        this.id = data.id || this.id;

        if (this.package) {
          this.package.setComponentName(this, data);
        } else {
          this.name = 'test';
        }

        this.setShortName();

        this.originalName = data.originalName || this.originalName;
        this.editorDirective = data.editorDirective || this.editorDirective;
        this.type = data.type || this.type;
        this.componentType = data.componentType || this.componentType;
        this.connectionTypes = data.connectionTypes || this.connectionTypes;
        this.icon = data.icon || this.icon;
        this.inputMin = data.inputMin || this.inputMin;
        this.inputMax = data.inputMax || this.inputMax;
        this.outputMin = data.outputMin || this.outputMin;
        this.outputMax = data.outputMax || this.outputMax;
        this.disableSchemaLoad = data.disableSchemaLoad || this.disableSchemaLoad;
        this.hasDataPreview = angular.isDefined(data.hasDataPreview) ? data.hasDataPreview : this.hasDataPreview;
        this.hasDataPreviewRefreshButton = angular.isDefined(data.hasDataPreviewRefreshButton)
          ? data.hasDataPreviewRefreshButton
          : this.hasDataPreviewRefreshButton;

        if (data.defaults) this.defaults = data.defaults;
        if (this.type !== 'transformation' && this.type !== 'workflow') {
          if (data.schema && this.schema) this.schema.setData(data.schema);
          if (data.connection && this.connection) this.connection.setData(data.connection);
        }

        if (this.designer) {
          if (data.xy) {
            this.x = this.snapToGrid(data.xy[0]);
            this.y = this.snapToGrid(data.xy[1]);
          } else {
            this.x = this.snapToGrid(this.designer.width / 2);
            this.y = this.cell * 3;
          }
        } else {
          this.x = this.designer ? this.snapToGrid(this.designer.width / 2) : 0;
          this.y = this.cell * 3;
        }

        if (this.package) this.package.checkComponentPosition(this);

        if (
          (this.type === 'source' || this.type === 'destination' || this.componentType === 'execute_sql_component') &&
          !this._data.connection
        ) {
          this._data.connection = {
            id: '',
            type: '',
          };
        }

        this.bind();
      };

      DesignerComponent.prototype.setElement = function (element) {
        this.element = element;
        this.$hover = element.find('.designer-component-hover');
        this.$background = element.find('.designer-component-background');
        this.$backgroundImage = element.find('.designer-component-bg');
        this.$name = element.find('.designer-component-name');
        this.$icon = element.find('.designer-component-icon');
        this.$duplicate = element.find('.designer-component-duplicate');
        this.$remove = element.find('.designer-component-remove');
        this.$add = element.find('.designer-component-add');
        this.$portSource = element.find('.designer-component-port-source');
        this.$portTarget = element.find('.designer-component-port-target');
        this.setPosition();
        this.initEvents();
        this.initiated = true;
        this.bind();
      };

      DesignerComponent.prototype.bind = function () {
        const _this = this;

        if (!this.initiated) return;

        this.$name.text(this.shortName);

        $timeout(function () {
          _this.$icon.attr('href', '#icons-sprite_' + _this.icon);
        });

        if (this.inputMin === 0) {
          this.$portTarget.hide();
        } else {
          this.$portTarget.show();
        }

        if (this.allowOutputs()) {
          this.$add.show();
        } else {
          this.$add.hide();
        }

        if (this.selected) {
          this.element[0].classList.add('selected');
        } else {
          this.element[0].classList.remove('selected');
        }

        if (this.connectable) {
          this.element[0].classList.add('connectable');
        } else {
          this.element[0].classList.remove('connectable');
        }

        if (this.valid()) {
          this.element[0].classList.remove('invalid');
          if (this.$backgroundImage[0]) {
            this.$backgroundImage[0].removeAttribute('style');
          }
        } else {
          this.element[0].classList.add('invalid');
          if (this.$backgroundImage[0]) {
            this.$backgroundImage[0].setAttribute('style', `fill: url(${this.absUrl()}#component-invalid)`);
          }
        }

        if (this.outputs > 0) {
          this.$portSource.show();
        } else {
          this.$portSource.hide();
        }
      };

      DesignerComponent.prototype.destroy = function () {
        if (this.componentSelectedDrag) this.componentSelectedDrag();
        if (this.componentSelectedDragStop) this.componentSelectedDragStop();
        if (this.edgeConnectorAdd) this.edgeConnectorAdd();
        if (this.edgeConnectorRemove) this.edgeConnectorRemove();
        if (this.edgeConnectorTargetOver) this.edgeConnectorTargetOver();
        if (this.edgeConnectorTargetOut) this.edgeConnectorTargetOut();
      };

      DesignerComponent.prototype.initEvents = function () {
        const _this = this;

        this.componentSelectedDrag = $rootScope.$on(DESIGNER_EVENTS.COMPONENT_SELECTED_DRAG, function (event, offset) {
          if (_this.selected && !_this.draggable) {
            _this.setOffset(offset);
          }
        });

        this.componentSelectedDragStop = $rootScope.$on(DESIGNER_EVENTS.COMPONENT_SELECTED_DRAG_STOP, function (
          event,
          offset,
        ) {
          if (_this.selected && !_this.draggable) {
            _this.setPosition({
              x: _this.x - offset.x,
              y: _this.y - offset.y,
            });
            _this.snapComponentToGrid();
          }
        });

        this.edgeConnectorAdd = $rootScope.$on(DESIGNER_EVENTS.EDGE_CONNECTOR_ADD, function () {
          if (_this.allowInputs()) _this.element[0].classList.add('target');
        });

        this.edgeConnectorRemove = $rootScope.$on(DESIGNER_EVENTS.EDGE_CONNECTOR_REMOVE, function () {
          if (_this.allowInputs()) _this.element[0].classList.remove('target');
        });

        let startPosition;
        const offsetX = 49;
        const offsetY = -45;
        let leftMousePosition;
        let topMousePosition;

        function getPositionsFromUIElement(ui, isSafari, event, diff = { x: 0, y: 0 }) {
          const { left, top } = event.target.getBoundingClientRect();
          const leftPosition = !isSafari ? ui.position.left : left - diff.x - 1;
          const topPosition = !isSafari ? ui.position.top : top - diff.y - 1;

          return { leftPosition, topPosition };
        }

        var getPosition = function (ui, event, diff) {
          const { leftPosition, topPosition } = getPositionsFromUIElement(ui, _this.designer.isSafari, event, diff);
          var x = Math.round((leftPosition + _this.designer.scrollLeft) / 1) - offsetX;
          var y = Math.round((topPosition + _this.designer.scrollTop) / 1) - offsetY;

          if (_this.designer.firefox) {
            y -= 30;
          }

          const $topHeader = $('.page-top-header');
          if ($topHeader.length) {
            y -= $topHeader.height();
          }

          const $herokuBoomerang = $('#heroku-boomerang');
          if ($herokuBoomerang.length) {
            y -= $herokuBoomerang.height();
          }

          if (x === -49) {
            return { x: _this.x, y: _this.y };
          }
          return { x, y };
        };

        this.element
          .draggable({
            start(event, ui) {
              _this.moveToLast();
              _this.setDraggable(true);
              startPosition = getPosition(ui, event);
              leftMousePosition = event.clientX;
              topMousePosition = event.clientY;
            },
            stop(event, ui) {
              if (_this.selected) {
                const position = getPosition(ui, event);
                $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_SELECTED_DRAG_STOP, {
                  x: startPosition.x - position.x,
                  y: startPosition.y - position.y,
                });
              }
              _this.designer.package.setSize();
              _this.snapComponentToGrid();
              _this.designer.history.save('Component position change');
              _this.package.update();
              $timeout(function () {
                _this.setDraggable(false);
              });
            },
            drag(event, ui) {
              const position = getPosition(ui, event, {
                x: leftMousePosition - event.clientX,
                y: topMousePosition - event.clientY,
              });
              _this.setPosition(position);
              _this.setEdgesPosition(position);
              leftMousePosition = event.clientX;
              topMousePosition = event.clientY;
              if (_this.selected) {
                $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_SELECTED_DRAG, {
                  x: startPosition.x - position.x,
                  y: startPosition.y - position.y,
                });
              }
            },
          })
          .disableSelection();

        this.element.on('mouseover', function () {
          if (_this.connectorDraggable) {
            _this.moveToFirst();
          } else {
            _this.moveToLast();
          }
        });

        this.$remove.on('click', function () {
          _this.package.removeComponent(_this);
        });

        this.$duplicate.on('click', function () {
          _this.package.duplicateComponent(_this);
        });

        this.$background.on('click', function () {
          if (!_this.draggable) {
            ngrxStoreService.dispatch(openComponentsModal({ componentId: _this.id }));
            $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_EDIT, _this);
          }
        });

        this.element.on('mouseenter', function () {
          _this.setHover(true);
          $rootScope.$broadcast(DESIGNER_EVENTS.EDGE_CONNECTOR_TARGET_OVER, _this);
        });

        this.element.on('mouseleave', function () {
          _this.setHover(false);
          $rootScope.$broadcast(DESIGNER_EVENTS.EDGE_CONNECTOR_TARGET_OUT, _this);
        });

        this.$add.on('click', function () {
          const workflow = _this.package.flow_type === 'workflow';

          $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_MENU, {
            sources: false,
            transformations: !workflow,
            distanations: !workflow,
            workflow,
            sourceComponentId: _this.id,
          });
        });

        this.initEventsForAdd();
      };

      DesignerComponent.prototype.initEventsForAdd = function () {
        const _this = this;
        const $rect = this.$add.find('rect');
        const $path = this.$add.find('path');
        const $polygon = this.$add.find('polygon');

        let edge;
        let startPosition;
        const rectRadius = 14;
        let startRectX = 0;
        let startRectY = 0;

        let targetComponent;
        let componentToConnect = null;

        const setPosition = function (position) {
          _this.$add.attr('style', `transform: translate(${position.left}px, ${position.top}px)`);

          targetComponent.setPosition(
            position.left + _this.x + startRectX - _this.designer.scrollLeft,
            position.top + _this.y + _this.height + startRectY - _this.designer.scrollTop,
          );

          $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_POSITION_CHANGE + targetComponent.id, {
            x: targetComponent.x,
            y: targetComponent.y,
          });
        };

        const getPosition = function (ui) {
          let x = 0;
          let y = 0;

          if (_this.designer.firefox) {
            x = Math.round((ui.position.left + _this.designer.scrollLeft) / 1);
            y = Math.round((ui.position.top + _this.designer.scrollTop) / 1);
          } else {
            x = Math.round((ui.position.left + _this.designer.scrollLeft - _this.x) / 1);
            y = Math.round((ui.position.top + _this.designer.scrollTop - _this.y - _this.height) / 1);
          }

          return {
            left: x,
            top: y,
          };
        };

        const bindDraggable = function () {
          _this.element[0].classList.add('connecting');

          _this.connectorDraggable = true;

          _this.moveToFirst();

          $rect.attr('rx', rectRadius);
          $rect.attr('ry', rectRadius);

          $rect.attr('style', `transform: translate(${startRectX - rectRadius}px, ${startRectY - rectRadius}px)`);

          const edgeId = `add-${_this.uid()}`;

          const TargetComponent = function (x, y) {
            this.id = edgeId;
            this.x = x;
            this.y = y;

            this.getPosition = function () {
              return {
                x: this.x,
                y: this.y,
              };
            };

            this.setPosition = function (x, y) {
              this.x = x;
              this.y = y;
            };

            this.removeInput = function () {};
          };

          targetComponent = new TargetComponent(startRectX, startRectY);

          _this.edgeConnectorTargetOver = $rootScope.$on(DESIGNER_EVENTS.EDGE_CONNECTOR_TARGET_OVER, function (
            event,
            component,
          ) {
            component.setConnectable(true);
            componentToConnect = component;
          });

          _this.edgeConnectorTargetOut = $rootScope.$on(DESIGNER_EVENTS.EDGE_CONNECTOR_TARGET_OUT, function (
            event,
            component,
          ) {
            component.setConnectable(false);
            componentToConnect = null;
          });

          edge = _this.package.createEdge({
            id: edgeId,
            source: _this.id,
            target: edgeId,
            targetEdge: true,
            targetComponent,
          });

          $path.hide();
          $polygon.hide();

          _this.package.unselectAllComponents();

          $rootScope.$broadcast(DESIGNER_EVENTS.EDGE_CONNECTOR_ADD);
        };

        const unbindDraggable = function () {
          _this.element[0].classList.remove('connecting');

          $rect.attr('rx', 0);
          $rect.attr('ry', 0);
          $rect.attr('style', 'transform: translate(0px, 0px)');

          $timeout(function () {
            $path.show();
            $polygon.show();
            setPosition({
              left: 0,
              top: 81,
            });
          }, 250);

          _this.connectorDraggable = false;

          _this.package.removeEdge(edge);

          $rootScope.$broadcast(DESIGNER_EVENTS.EDGE_CONNECTOR_REMOVE);

          if (componentToConnect !== null && componentToConnect.allowInputs() && _this.allowOutputs()) {
            _this.package.createEdge({
              source: _this.id,
              target: componentToConnect.id,
              order: _this.package.getEdgeOrder(componentToConnect.id),
              source_index: _this.package.getEdgeSourceIndex(_this.id),
            });

            _this.setPosition();
            componentToConnect.setPosition();
          }
        };

        this.$add.draggable({
          start(event, ui) {
            const topHeader = document.querySelector('.page-top-header');
            const topHeaderHeight = topHeader ? topHeader.offsetHeight : 0;

            startRectX = event.offsetX - ui.position.left - 50;
            startRectY = event.offsetY - ui.position.top - topHeaderHeight;
            bindDraggable();
            $timeout(function () {
              startPosition = getPosition(ui, event);
              setPosition(startPosition);
            });
          },
          stop() {
            unbindDraggable();
          },
          drag(event, ui) {
            const position = getPosition(ui, event);
            setPosition(position);
          },
        });
      };

      DesignerComponent.prototype.setPosition = function (position) {
        const _this = this;

        if (position) {
          this.x = position.x;
          this.y = position.y;
        }

        if (!this.element) return;

        this.element.attr('transform', `translate(${this.x}, ${this.y})`);

        if (this.designer.firefox) {
          this.element.attr('style', `left:${this.x}px;top:${this.y}px;`);
        }

        _.each(this.inputEdges, function (inputEdge) {
          inputEdge.targetPosition = {
            x: _this.x + 2.5 * _this.cell,
            y: _this.y - 7,
          };
          inputEdge.setPosition();
        });

        _.each(this.outputEdges, function (outputEdge) {
          outputEdge.sourcePosition = {
            x: _this.x + 2.5 * _this.cell,
            y: _this.y + 3 * _this.cell + 8,
          };
          outputEdge.setPosition();
        });

        $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_POSITION_CHANGE + this.id, {
          x: this.x,
          y: this.y,
        });
      };

      DesignerComponent.prototype.getPosition = function () {
        return {
          x: this.x,
          y: this.y,
        };
      };

      DesignerComponent.prototype.setEdit = function (edit) {
        this.edit = edit;
      };

      DesignerComponent.prototype.clone = function () {
        const _data = this.getFormData();
        _data.inputMin = this.inputMin;
        _data.inputMax = this.inputMax;
        _data.outputMin = this.outputMin;
        _data.outputMax = this.outputMax;

        const _package = this.package;

        _data.id = `component-${this.uid()}`;
        _data.name = `copy_of_${this.name}`;

        while (this.package.componentNameExist(_data.name)) {
          _data.name = `copy_of_${_data.name}`;
        }

        if (!_data.xy) _data.xy = [];

        _data.xy[0] = this.x + this.width + this.cell;
        _data.xy[1] = this.y;

        const clone = this.package.createComponentByType(this.componentType, _data);

        return clone;
      };

      DesignerComponent.prototype.snapComponentToGrid = function () {
        const position = {
          x: this.snapToGrid(this.x),
          y: this.snapToGrid(this.y),
        };
        this.package.checkComponentPosition(position);
        this.setPosition(position);
      };

      DesignerComponent.prototype.setOffset = function (offset) {
        this.element.attr('transform', `translate(${this.x - offset.x}, ${this.y - offset.y})`);
        const _this = this;

        _.each(this.inputEdges, function (inputEdge) {
          inputEdge.targetPosition = {
            x: _this.x - offset.x + 2.5 * _this.cell,
            y: _this.y - offset.y - 7,
          };
          inputEdge.setPosition();
        });

        _.each(this.outputEdges, function (outputEdge) {
          outputEdge.sourcePosition = {
            x: _this.x - offset.x + 2.5 * _this.cell,
            y: _this.y - offset.y + 3 * _this.cell + 8,
          };
          outputEdge.setPosition();
        });

        $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_OFFSET_CHANGE + this.id, {
          x: this.x - offset.x,
          y: this.y - offset.y,
        });
      };

      DesignerComponent.prototype.setSelection = function (selected) {
        if (this.selected !== selected) {
          this.selected = selected;
          $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_SELECTION_CHANGED);
          this.bind();
        }
      };

      DesignerComponent.prototype.setConnectable = function (connectable) {
        this.connectable = connectable;
        this.bind();
      };

      DesignerComponent.prototype.setDraggable = function (draggable) {
        this.draggable = draggable;
        if (draggable) {
          this.element[0].classList.add('draggable');
        } else {
          this.element[0].classList.remove('draggable');
        }
      };

      DesignerComponent.prototype.setHover = function (hover) {
        this.hover = hover;
        if (hover && !this.connectorDraggable) {
          this.element[0].classList.add('hover');
          this.$add.find('rect').attr({
            width: 140,
            height: 28,
          });
        } else {
          this.element[0].classList.remove('hover');
          this.$add.find('rect').removeAttr('width height');
        }
      };

      DesignerComponent.prototype.allowOutputs = function () {
        return this.outputs < this.outputMax;
      };

      DesignerComponent.prototype.allowInputs = function () {
        return this.inputs < this.inputMax;
      };

      // EDGES
      //-----------------------------------------------------
      //-----------------------------------------------------
      //-----------------------------------------------------

      DesignerComponent.prototype.addOutput = function (output) {
        this.outputEdges.push(output);
        this.outputs++;
        this.bind();
      };

      DesignerComponent.prototype.removeOutput = function (output) {
        const index = this.outputEdges.indexOf(output);
        this.outputEdges.splice(index, 1);
        this.outputs--;
        this.bind();
      };

      DesignerComponent.prototype.addInput = function (output) {
        this.inputEdges.push(output);
        this.inputs++;
        this.bind();
      };

      DesignerComponent.prototype.removeInput = function (output) {
        const index = this.inputEdges.indexOf(output);
        this.inputEdges.splice(index, 1);
        this.inputs--;
        this.bind();
      };

      // TODO: should replace edge position
      DesignerComponent.prototype.setEdgesPosition = function (positions) {};

      // DATA
      //-----------------------------------------------------
      //-----------------------------------------------------
      //-----------------------------------------------------

      DesignerComponent.prototype.valid = function () {
        let valid = true;

        if (this.outputs < this.outputMin) {
          valid = false;
        }

        if (this.inputs < this.inputMin) {
          valid = false;
        }

        return valid;
      };

      DesignerComponent.prototype.isNameValid = function (name) {
        const format = REGEXES.FIELD_NAME_FORMAT;
        const keywords = REGEXES.RESERVED_KEYWORDS;

        const isUnique = !this.designer.package.componentNameExist(name);
        const isFormatValid = format.test(name);
        const isKeywordValid = !keywords.test(name);

        return isUnique && isFormatValid && isKeywordValid;
      };

      DesignerComponent.prototype.getSchema = function () {
        let schema;

        if (this.schema) {
          schema = this.schema.getSchema();
        } else {
          const schemas = this.getParentComponentsSchemas();

          if (!schemas.length) {
            schema = new DesignerSchema();
          } else if (schemas.length === 1) {
            schema = schemas[0];
          } else {
            schema = new DesignerSchema();
            _.each(schemas, (inputSchema) => {
              schema.fields = _(schema.fields).concat(inputSchema.fields).value();
            });
          }
        }

        switch (this.componentType) {
          case 'rank_component':
            schema.fields.unshift({
              alias: this._data.field_alias,
              name: this._data.field_alias,
            });
            break;
        }

        schema.id = this.id;
        schema.name = this.name;

        return schema;
      };

      DesignerComponent.prototype.getParentComponentsSchemas = function (ordered) {
        if (ordered && this.inputEdges.length) {
          const maxOrder = _.max(this.inputEdges, 'order').order;
          var schemas = new Array(maxOrder + 1);
          _.each(this.inputEdges, function (inputEdge) {
            const schema = inputEdge.sourceComponent.getSchema();
            schemas[inputEdge.order] = schema;
          });
        } else {
          var schemas = [];
          _.each(this.inputEdges, function (inputEdge) {
            const sourceSchema = inputEdge.sourceComponent.getSchema();
            if (sourceSchema) {
              schemas.push(sourceSchema);
            }
          });
        }

        return schemas;
      };

      DesignerComponent.prototype.getData = function () {
        const data = {
          id: this.id,
          name: this.name,
          alias: this.name,
          xy: [this.x, this.y],
        };

        if ((this.type === 'source' || this.type === 'destination') && this.connection) {
          data.connection = this.connection.getData();
        }

        if (this.type === 'source' && this.schema) {
          data.schema = this.schema.getData();
        }

        return data;
      };

      DesignerComponent.prototype.setFormData = function (formData) {
        const isNew = angular.isUndefined(formData.name);

        this.name = this._data.name = formData.name || '';

        this.setShortName();
        if (this.type !== 'transformation' && this.type !== 'workflow') {
          this.schema.setData(formData.schema);
          this.connection.setData(formData.connection);
        }
        switch (formData.componentType) {
          case 'amazon_redshift_source_component':
            this._data.connection = formData.connection;
            this._data.connection_id = formData.connection.id;
            this._data.database_connection_id = String(formData.connection.id) || '';
            this._data.table_name = formData.table_name || '';
            this._data.schema_name = formData.schema_name || '';
            this._data.null_string = formData.null_string || '';
            this._data.where_clause = formData.where_clause || '';
            this._data.split_by_column_name = formData.split_by_column_name || '';
            this._data.parallel = formData.parallel || '';
            break;

          case 'mongo_source_component':
            this._data.connection = formData.connection;
            this._data.database_connection_id = formData.connection.connection;
            this._data.table_name = formData.table_name;
            this._data.where_clause = formData.where_clause;
            break;

          case 'adwords_source_component':
            this._data.connection = formData.connection;
            this._data.cloud_storage_connection_id = formData.connection.id;
            this._data.customer_ids = formData.customer_ids;
            this._data.api_version = formData.api_version;
            this._data.report_type = formData.report_type;
            this._data.report_date_range_type = formData.report_date_range_type;
            this._data.report_date_range_min = formData.report_date_range_min;
            this._data.report_date_range_max = formData.report_date_range_max;
            this._data.customer_id_field_alias = formData.customer_id_field_alias;
            break;

          case 'net_suite_source_component':
            this._data.connection = formData.connection;
            this._data.database_connection_id = formData.database_connection_id;
            this._data.table_name = formData.table_name;
            this._data.where_clause = formData.where_clause;
            this._data.null_string = formData.null_string;
            this._data.schema = this.schema.getData();
            break;

          case 'rank_component':
            this._data.fields = formData.fields;
            break;

          case 'window_component':
            this._data.partitioned_fields = formData.partitioned_fields;
            this._data.ordered_fields = formData.ordered_fields;
            this._data.windowed_fields = formData.windowed_fields;
            break;

          case 'sample_component':
            this._data.percentage = formData.percentage;
            break;

          case 'join_component':
            this._data.join_type = formData.join_type;
            this._data.optimization_type = formData.optimization_type;
            this._data.parallel = formData.parallel;
            this._data.relations = formData.relations;
            break;

          case 'filter_component':
            this._data.predicates = formData.predicates;
            break;

          case 'distinct_component':
            this._data.parallel = formData.parallel;
            break;

          case 'run_package_component':
            this._data.package_id = formData.package_id;
            this._data.operator = formData.operator;
            this._data.variables = formData.variables;
            break;

          case 'notify_component':
            this._data.email = formData.email;
            this._data.subject = formData.subject;
            this._data.message = formData.message;
            break;
        }

        this.bind();

        if (this.designer.initiated) {
          this.designer.history.save('Component data changed');
          this.package.update();
        }
      };

      DesignerComponent.prototype.getFormData = function () {
        const formData = {
          type: this.type,
          editorDirective: this.editorDirective,
          componentType: this.componentType,
          connectionTypes: this.connectionTypes,
          icon: this.icon,
          originalName: this.originalName,
          disableSchemaLoad: this.disableSchemaLoad,
          hasDataPreview: this.hasDataPreview,
          hasDataPreviewRefreshButton: this.hasDataPreviewRefreshButton,
          defaults: this.defaults || {},
          inputMin: this.inputMin,
          inputMax: this.inputMax,
        };

        return _.extend(this.getData(), formData);
      };

      DesignerComponent.prototype.getParentSchema = function () {
        const schema = new DesignerSchema();

        if (this.inputEdges.length > 0) {
          _.each(this.inputEdges, function (inputEdge) {
            const parentSchema = inputEdge.sourceComponent.getSchema();
            _.each(parentSchema.fields, function (field) {
              schema.addField(field);
            });
          });
        }

        return schema;
      };

      DesignerComponent.prototype.setShortName = function () {
        const maxLength = 15;

        this.shortName = this.name.length > maxLength ? `${this.name.substr(0, maxLength)} ..` : this.name;
      };

      DesignerComponent.prototype.setInputComponentsOrder = function (components) {
        const _this = this;

        _.each(components, function (component, index) {
          const edge = _.find(_this.inputEdges, { source: component.id });
          if (edge) edge.order = index;
        });
      };

      return DesignerComponent;
    },
  ]);
})(window.angular);
